<template>
  <div class="container">
    <v-expansion-panels>
      <v-expansion-panel isActive="true">
        <v-expansion-panel-header>
            Φίλτρα αναζήτησης
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row>
            <v-col cols="12" sm="6">
              <v-menu
                  v-model="menu1"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          v-model="documentIssueDateStartFilter"
                          label="Ημερομηνία έκδοσης (Από)"
                          append-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          clearable>
                      </v-text-field>
                  </template>
                  <v-date-picker
                      v-model="documentIssueDateStartFilter"
                      @input="menu1 = false">
                  </v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" sm="6">
                <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="documentIssueDateStopFilter"
                            label="Ημερομηνία έκδοσης (Έως)"
                            append-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            clearable>
                        </v-text-field>
                    </template>
                    <v-date-picker
                        v-model="documentIssueDateStopFilter"
                        @input="menu2 = false">
                    </v-date-picker>
                </v-menu>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="6">
                <v-select 
                    v-bind:items="documentTypes" 
                    v-model="documentTypeFilter"
                    return-object
                    
                    item-text="description" 
                    label="Είδος παραστατικού"
                    v-bind:error-messages="allerrors['params.document_types']"
                    clearable>
                </v-select>
            </v-col>
            <v-col cols="12" sm="6">
                <v-autocomplete 
                    v-model="selectedAccount"
                    v-bind:items="accounts"
                    return-object
                    
                    item-text="searchableName"
                    label="Συναλασσόμενος"
                    append-icon="mdi-account-search" 
                    v-bind:error-messages="allerrors['params.account_id']"
                    clearable>
                </v-autocomplete>
            </v-col>
        </v-row>

          <v-row class="my-3" cols="12" align="center" justify="center">
            <v-btn 
                color="success" 
                rounded
                elevation="2"
                class="mx-2 px-5 font-weight-bold white--text"
                @click="getData" 
                :loading="getDataButtonDisabled"
            >
                <v-icon left size="20">mdi-magnify</v-icon>
                <span>ΑΝΑΖΗΤΗΣΗ</span>
            </v-btn>

            <v-btn 
                color="orange darken-2" 
                dark
                rounded
                elevation="2"
                class="mx-2 px-5 font-weight-bold white--text"
                @click="clearFilters" 
            >
                <v-icon left size="20">mdi-broom</v-icon>
                <span>ΚΑΘΑΡΙΣΜΑ</span>
            </v-btn>
          </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>

    <v-data-table
      :headers="headers"
      :item-class="row_class_generator"
      :items="items"
      :loading="loading"
      loading-text="Φόρτωση κινήσεων καρτέλας..."
      no-data-text="Δεν υπάρχουν δεδομένα"
      :sort-by="['date']"
      :sort-desc="true"
      class="elevation-1 my-2"
      disable-pagination
      disable-filtering
      disable-sort
      hide-default-footer>
      
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Κινήσεις καρτέλας</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          
          <v-spacer></v-spacer>
          <v-menu 
            v-if="showExport"
            offset-y 
            transition="slide-y-transition"
            rounded="lg"
            elevation="8"
            min-width="290"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                rounded
                elevation="2"
                class="mb-2 px-4 font-weight-bold white--text"
                v-bind="attrs"
                v-on="on"
                :loading="exportLoading"
              >
                <v-icon left size="20">mdi-cloud-download-outline</v-icon>
                <span>ΕΞΑΓΩΓΗ</span>
                <v-icon right size="18" class="ml-1">mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-card flat>
              <v-list dense class="py-1">
                <v-subheader class="text-uppercase font-weight-bold text-caption grey--text text--darken-1 px-4 py-0" style="height: 28px;">
                  Επιλογές Εξαγωγής
                </v-subheader>

                <v-list-item link @click="excelPlease" class="px-3 py-1">
                  <v-list-item-avatar size="36" color="green lighten-5" class="my-1 mr-3">
                    <v-icon color="green darken-1" size="22">mdi-file-excel</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium text-body-2">
                      1. Εξαγωγή σε Excel
                    </v-list-item-title>
                    <v-list-item-subtitle class="text-caption grey--text">
                      Αρχείο .xlsx
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action class="my-0">
                    <v-icon small color="grey lighten-1">mdi-chevron-right</v-icon>
                  </v-list-item-action>
                </v-list-item>

                <v-divider class="my-1 mx-2"></v-divider>

                <v-list-item link @click="pdfPlease" class="px-3 py-1">
                  <v-list-item-avatar size="36" color="red lighten-5" class="my-1 mr-3">
                    <v-icon color="red darken-1" size="22">mdi-file-pdf-box</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium text-body-2">
                      2. Εξαγωγή σε PDF
                    </v-list-item-title>
                    <v-list-item-subtitle class="text-caption grey--text">
                      Εκτυπώσιμη καρτέλα (.pdf)
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action class="my-0">
                    <v-icon small color="grey lighten-1">mdi-chevron-right</v-icon>
                  </v-list-item-action>
                </v-list-item>

                <v-divider class="my-1 mx-2"></v-divider>

                <v-list-item link @click="openMailDialog" class="px-3 py-1">
                  <v-list-item-avatar size="36" color="blue lighten-5" class="my-1 mr-3">
                    <v-icon color="blue darken-2" size="22">mdi-email-send-outline</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium text-body-2">
                      3. Αποστολή με Email
                    </v-list-item-title>
                    <v-list-item-subtitle class="text-caption grey--text">
                      Επισύναψη PDF στον πελάτη
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action class="my-0">
                    <v-icon small color="grey lighten-1">mdi-chevron-right</v-icon>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </v-card>
          </v-menu>

          <v-dialog v-model="dialogMail" max-width="500px">
            <v-card>
              <v-card-title class="text-h5">Αποστολή email</v-card-title>
              <v-card-text>
                <v-text-field 
                  v-model="mailRecipientAddress"
                  label="Διεύθυνση αποστολής"
                  hint="Για πολλαπλά email διαχωρίστε με ; (π.χ. email1@test.gr; email2@test.gr)"
                  persistent-hint>
                </v-text-field>
                <v-checkbox v-model="saveMailAddress" label="Αποθήκευση διεύθυνσης email"/>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary darken-1" text @click="closeMail">ΑΚΥΡΟ</v-btn>
                <v-btn color="success darken-1" @click="mailConfirm" v-bind:loading="mailButtonDisabled">ΕΝΤΑΞΕΙ</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- Dialog for Document Mail -->
          <v-dialog v-model="dialogDocumentMail" max-width="500px">
            <v-card>
              <v-card-title class="text-h6 d-flex align-center">
                <v-icon left color="primary" class="mr-2">mdi-email-send</v-icon>
                Αποστολή παραστατικού με email
              </v-card-title>
              <v-card-subtitle class="mt-1 pb-1" v-if="selectedDocumentForMail">
                <strong>{{ selectedDocumentForMail.documentTypeDescription }}</strong> {{ selectedDocumentForMail.documentNumber ? '(Αρ. ' + selectedDocumentForMail.documentNumber + ')' : '' }}
              </v-card-subtitle>
              <v-card-text>
                <v-text-field 
                  v-model="documentMailRecipient"
                  label="Διεύθυνση αποστολής"
                  hint="Για πολλαπλά email διαχωρίστε με ; (π.χ. email1@test.gr; email2@test.gr)"
                  persistent-hint
                  outlined
                  dense
                  class="mt-2"
                >
                </v-text-field>
                <v-checkbox 
                  v-model="saveDocumentMailAddress" 
                  label="Αποθήκευση διεύθυνσης email στον συναλλασσόμενο"
                  dense
                  hide-details
                  class="mt-2"
                />
              </v-card-text>
              <v-card-actions class="pb-4 px-4">
                <v-spacer></v-spacer>
                <v-btn color="grey darken-1" text @click="closeDocumentMail">ΑΚΥΡΟ</v-btn>
                <v-btn 
                  color="success" 
                  rounded
                  elevation="2"
                  class="px-4 font-weight-bold white--text"
                  @click="sendDocumentMailConfirm" 
                  :loading="documentMailLoading"
                >
                  <v-icon left small>mdi-send</v-icon>
                  ΑΠΟΣΤΟΛΗ
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      
      <template v-slot:[`item.date`]="{ item }">
        {{ formatDate(item.date) }}
      </template>


      <template v-slot:[`item.debit`]="{ item }">
        {{ formatMoney(item.debit) }}
      </template>

      <template v-slot:[`item.credit`]="{ item }">
        {{ formatMoney(item.credit) }}
      </template>

      <template v-slot:[`item.oldBalance`]="{ item }">
        {{ formatMoney(item.oldBalance) }}
      </template>

      <template v-slot:[`item.newBalance`]="{ item }">
        {{ formatMoney(item.newBalance) }}
      </template>


          <template v-slot:[`item.actions`]="{ item }">
        <div v-if="item.printUrl" class="text-no-wrap">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                small
                color="primary"
                v-bind="attrs"
                v-on="on"
                @click="printDocument(item)"
              >
                <v-icon small>mdi-printer</v-icon>
              </v-btn>
            </template>
            <span>Εκτύπωση παραστατικού</span>
          </v-tooltip>

          <v-tooltip bottom v-if="item.mailerUrl">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                small
                color="indigo"
                v-bind="attrs"
                v-on="on"
                @click="openDocumentMailDialog(item)"
              >
                <v-icon small>mdi-email</v-icon>
              </v-btn>
            </template>
            <span>Αποστολή με email</span>
          </v-tooltip>
        </div>
      </template>

    </v-data-table>
  </div>
</template>

<script>
  import moment from "moment";

  export default {
    data: () => ({
      loading: false,
      allerrors : {
        
      },

      dialog: false,

      headers: [
        {
          text: 'Ημερομηνία',
          align: 'start',
          value: 'date',
          exportTransformer: (cell) => moment(cell).format("DD/MM/YYYY")
        },
        { 
          text: 'Είδος Παραστατικού', 
          align: 'left',
          value: 'documentTypeDescription' 
        },
        { 
          text: 'Αρ. Παραστατικού', 
          align: 'left',
          value: 'documentNumber' 
        },
        { 
          text: 'Χρέωση', 
          align: 'right',
          value: 'debit',
          exportTransformer: (cell) => cell.toString().replace('.', ',') 
        },
        { 
          text: 'Πίστωση', 
          align: 'right',
          value: 'credit',
          exportTransformer: (cell) => cell.toString().replace('.', ',')
        },
        { 
          text: 'Παλιό Υπόλοιπο', 
          align: 'right',
          value: 'oldBalance',
          exportTransformer: (cell) => cell.toString().replace('.', ',') 
        },
        { 
          text: 'Νέο υπόλοιπο', 
          align: 'right',
          value: 'newBalance',
          exportTransformer: (cell) => cell.toString().replace('.', ',') 
        },
        {
          text: 'Ενέργειες',
          align: 'center',
          value: 'actions',
          sortable: false,
          exportable: false,
          width: '110px'
        },
        

      ],

      items: [],


      documentTypes: [],
      accounts: [],

      selectedAccount: {},

      documentTypeFilter: null,

      documentIssueDateStartFilter: null,
      documentIssueDateStopFilter: null,

      getDataButtonDisabled: false,
      getExcelButtonDisabled: false,

      menu2: null,
      menu1: null,

      dialogDocumentMail: false,
      selectedDocumentForMail: null,
      documentMailRecipient: '',
      saveDocumentMailAddress: false,
      documentMailLoading: false,

      dialogMail: false,
      mailRecipientAddress: '',
      saveMailAddress: false,
      mailButtonDisabled: false,
      exportLoading: false,


    }),

    watch: {

    },

    created () {
      this.initialize()
    },

    computed: {
      showExport() {
        return this.items?.length > 0
      }
    },

    methods: {
            printDocument(item) {
        if (!item.printUrl) {
          if (this.$swal) this.$swal.fire('Προσοχή', 'Δεν υπάρχει διαθέσιμο εκτυπωτικό για τη γραμμή αυτή.', 'warning');
          return;
        }
        window.open(item.printUrl, '_blank').focus();
      },

      openDocumentMailDialog(item) {
        this.selectedDocumentForMail = item;
        this.documentMailRecipient = item.recipientEmail || this.selectedAccount?.email || '';
        this.saveDocumentMailAddress = false;
        this.dialogDocumentMail = true;
      },

      closeDocumentMail() {
        this.dialogDocumentMail = false;
        this.selectedDocumentForMail = null;
        this.documentMailRecipient = '';
        this.saveDocumentMailAddress = false;
      },

      sendDocumentMailConfirm() {
        if (!this.selectedDocumentForMail || !this.selectedDocumentForMail.mailerUrl) return;
        if (!this.documentMailRecipient || !this.documentMailRecipient.trim()) {
          if (this.$swal) this.$swal.fire('Προσοχή', 'Παρακαλώ συμπληρώστε διεύθυνση email.', 'warning');
          return;
        }

        this.documentMailLoading = true;
        axios.post(this.selectedDocumentForMail.mailerUrl, {
          document_id: this.selectedDocumentForMail.documentId,
          email_address: this.documentMailRecipient,
          save_email: this.saveDocumentMailAddress ? true : false
        }).then(response => {
          if (this.saveDocumentMailAddress && this.selectedAccount) {
            this.selectedAccount.email = this.documentMailRecipient;
            const acc = this.accounts.find(a => a.id === this.selectedAccount.id);
            if (acc) {
              acc.email = this.documentMailRecipient;
            }
          }
          if (this.$swal) {
            this.$swal.fire('Επιτυχία', 'Το παραστατικό απεστάλη επιτυχώς με email.', 'success');
          }
          this.closeDocumentMail();
        }).catch(error => {
          console.error(error);
          let msg = 'Σφάλμα κατά την αποστολή του email.';
          if (error.response && error.response.data && error.response.data.message) {
            msg = error.response.data.message;
          }
          if (this.$swal) {
            this.$swal.fire('Σφάλμα', msg, 'error');
          }
        }).finally(() => {
          this.documentMailLoading = false;
        });
      },

      excelPlease() {
        if (this.items?.length > 0 == false) {
          console.log('No items!')
          return
        }

        const transform = (line, columnDefinitions) => {
          let out = []

          columnDefinitions.forEach(columnDefinition => {

            const columnValue = line[columnDefinition.propertyName]

            if (columnDefinition.exportTransformer && columnValue != null)
              out.push(columnDefinition.exportTransformer(columnValue))
            else
              out.push(columnValue)
          });

          return out;
        }

        const exportableColumns = this.headers.filter(x => (x.exportable ?? true) == true)
        const columnDefinitions = exportableColumns.map(x => ({ propertyName: x.value, exportTransformer: x.exportTransformer }))

        const requestBody = {
          table_headers: exportableColumns.map(x => x.text),
          table_entries: this.items.filter(item => item.canceled == false).map(line => transform(line, columnDefinitions))
        }

        const safeName = (this.selectedAccount && this.selectedAccount.name) ? `_${this.selectedAccount.name}` : ''
        this.axiosDownload('/api/test', requestBody, `καρτέλα${safeName}.xlsx`)
      },

      pdfPlease() {
        if (!this.selectedAccount?.id) {
          if (this.$swal) this.$swal.fire('Προσοχή', 'Παρακαλώ επιλέξτε συναλλασσόμενο.', 'warning');
          return;
        }
        const safeName = (this.selectedAccount && this.selectedAccount.name) ? `_${this.selectedAccount.name}` : '';
        this.axiosDownload('/api/accounts/ledger/pdf', { params: this.getRequestParams() }, `καρτέλα${safeName}.pdf`);
      },

      openMailDialog() {
        if (!this.selectedAccount?.id) {
          if (this.$swal) this.$swal.fire('Προσοχή', 'Παρακαλώ επιλέξτε συναλλασσόμενο.', 'warning');
          return;
        }
        this.mailRecipientAddress = this.selectedAccount.email || '';
        this.saveMailAddress = false;
        this.dialogMail = true;
      },

      mailConfirm() {
        this.mailButtonDisabled = true;
        axios.post('/api/accounts/ledger/mail', {
          params: this.getRequestParams(),
          email_address: this.mailRecipientAddress,
          save_email: this.saveMailAddress ? true : false
        }).then(response => {
          if (this.saveMailAddress && this.selectedAccount) {
            this.selectedAccount.email = this.mailRecipientAddress;
            const acc = this.accounts.find(a => a.id === this.selectedAccount.id);
            if (acc) {
              acc.email = this.mailRecipientAddress;
            }
          }
          if (this.$swal) {
            this.$swal.fire('Επιτυχία', response.data.message || 'Η καρτέλα απεστάλη επιτυχώς με email.', 'success');
          }
          this.closeMail();
        }).catch(error => {
          console.log(error);
          let msg = 'Σφάλμα κατά την αποστολή του email.';
          if (error.response && error.response.data && error.response.data.message) {
            msg = error.response.data.message;
          }
          if (this.$swal) {
            this.$swal.fire('Σφάλμα', msg, 'error');
          }
        }).finally(() => {
          this.mailButtonDisabled = false;
        });
      },

      closeMail() {
        this.mailRecipientAddress = '';
        this.saveMailAddress = false;
        this.dialogMail = false;
      },

      row_class_generator(item) {

        if (item.canceled == true)
          return 'cancelled'

        return ''
      },

      axiosDownload(url, requestBody, filename) {
        this.exportLoading = true;
        this.getExcelButtonDisabled = true;

        axios({
            url: url, 
            data: requestBody,
            method: 'POST',
            responseType: 'blob', // important
        }).then((response) => {
            const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = blobUrl;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(blobUrl);
        }).catch(err => { 
            console.log(err); 
            if (this.$swal) {
              this.$swal.fire('Σφάλμα', 'Παρουσιάστηκε σφάλμα κατά τη λήψη του αρχείου.', 'error');
            }
        }).finally(() => {
            this.exportLoading = false;
            this.getExcelButtonDisabled = false;
        });
      },

      formatDate(value) {
        return moment(value).format("DD/MM/YYYY")
      },

      formatMoney(amount) {
        if (amount == null)
          amount = 0.0

        return amount.toFixed(2)
      },


      initialize () {
        this.$store.dispatch('currentUser/getCurrentUser')
        
        const initialDaysBeforeFilterValue = 30

        const today = new Date();

        let filterStart = new Date()
        filterStart.setDate(today.getDate() - initialDaysBeforeFilterValue);

        this.documentIssueDateStartFilter = this.$localDateString(filterStart)
        // this.documentIssueDateStopFilter = today.toISOString().split('T')[0]

        // this.getData();
        this.getFilterValues()

        
        
        this.documentTypeFilter = this.documentTypes[0]  // Default to 'with VAT'

      },

      getFilterValues() {
        // axios.get('/api/document-types/sales')
        //   .then(response => this.documentTypes = response.data)
        //   .catch(error => { console.log(error) })

        this.documentTypes = [
          {
            id: false,
            description: 'ΜΕ ΦΠΑ'
          },
          {
            id: true,
            description: 'ΑΝΕΞΑΡΤΗΤΑ ΦΠΑ'
          }
        ]

        axios.get('/api/accounts')
          .then( response => { 
		this.accounts = response.data;

		for (let i = 0; i < this.accounts.length; i++) {
			let account = this.accounts[i];
			this.accounts[i].searchableName = `${account.tax_registration_number} - ${account.name}`;
		}
	})
          .catch( error => { console.log(error) })

      },
      
      getRequestParams() {
        let out = {
          account_id: this.selectedAccount?.id ?? null,
          document_types: this.documentTypeFilter?.id
        }


        if (this.documentIssueDateStartFilter != null)
          out.issue_date_start = this.documentIssueDateStartFilter

        if (this.documentIssueDateStopFilter != null)
          out.issue_date_stop = this.documentIssueDateStopFilter

        
        return out
      },

      getData() {
        this.loading = true;
        this.allerrors = {}
        this.getDataButtonDisabled = true;
        axios.post(
            '/api/accounts/ledger', 
            {
                params: this.getRequestParams()
            }
        )
        .then(response => {
          this.items = response.data.entries;
          if (response.data.account && this.selectedAccount) {
            this.selectedAccount = Object.assign({}, this.selectedAccount, response.data.account);
          }
        })
        .finally(() => {
          this.getDataButtonDisabled = false;
          this.loading = false;
        })
        .catch(error => { 
          if (error.response.data)
              this.allerrors = error.response.data.errors
         })
        
      },


      clearFilters() {
        this.selectedAcount = {}
        this.documentIssueDateStartFilter = null
        this.documentIssueDateStopFilter = null
      }
    }
  }
</script>

<style lang="css">
  tr.cancelled {
    background-color:lightpink;
    text-decoration: line-through;
  }
</style>
